import route from "ziggy-js";
import { Globe, Settings, Shield } from "lucide-vue-next";
import type TabItem from "@/types/Settings/TabItem";
import { usePage } from "@inertiajs/vue3";
import type { IRhizomPageProps } from "@/types/RhizomPageProps/RhizomPageProps.ts";

type TranslateFn = (key: string) => string;

export const buildDomainReportTabs = (
    domain: string,
    isDomainParked: boolean,
    t: TranslateFn,
): TabItem[] => {
    const tabs: TabItem[] = [
        {
            title: t("vue.reports"),
            key: "domain-reports",
            icon: Globe,
            url: route("reports.show", { domain }),
        },
        {
            title: t("vue.dmarc_management"),
            key: "domain-dmarc-management",
            icon: Shield,
            url: route("reports.dmarc-management.show", { domain }),
        },
        {
            title: t("vue.settings"),
            key: "domain-settings",
            icon: Settings,
            url: route("reports.settings.show", { domain }),
        },
    ];

    if (isDomainParked) {
        tabs.splice(0, 2);
    }

    return tabs;
};
